"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// let isomorphic mock window.fetch if needed
// @ts-expect-error: no types declaration
var whatwg = require("whatwg-fetch");
/**
 * The memory reference to window.fetch is pointing to the native implementation. (Or the mock)
 * Once DD RUM wraps window.fetch it will become a different memory pointer but isomorphic is already pointing to the non-wrapped memory reference.
 */
function fetch() {
    // eslint-disable-next-line prefer-spread, prefer-rest-params
    return window.fetch.apply(window, arguments);
}
exports.DOMException = whatwg === null || whatwg === void 0 ? void 0 : whatwg.DOMException;
exports.Headers = whatwg === null || whatwg === void 0 ? void 0 : whatwg.Headers;
exports.Request = whatwg === null || whatwg === void 0 ? void 0 : whatwg.Request;
exports.Response = whatwg === null || whatwg === void 0 ? void 0 : whatwg.Response;
exports.fetch = fetch;
module.exports = fetch;
//# sourceMappingURL=webpack-entry-fetch.js.map